import React from 'react';
import { attentionReasonsOf } from '../../features/attention/attentionUtils';

const TONE_CLASSES = {
  danger: 'bg-red-50 text-red-500 dark:bg-red-900/20',
  warning: 'bg-orange-100 text-warning dark:bg-orange-900/20',
  neutral: 'bg-ninja-gray dark:bg-[#2d2d2d] text-text-secondary',
};

/**
 * The "Motivo" cell of the attention queue: each reason the row is there, and
 * what makes it so. Shared by the three workspaces so the queue explains itself
 * the same way to everybody.
 *
 * @param {object} props
 * @param {object} props.row - A row of `api/deliveries/attention/`.
 */
export const AttentionReasons = ({ row }) => {
  const reasons = attentionReasonsOf(row);

  if (reasons.length === 0) {
    return <span className="text-xs text-text-muted">—</span>;
  }

  return (
    <div className="flex flex-col items-start gap-1.5">
      {reasons.map((reason) => (
        <div
          key={reason.key}
          data-testid="attention-row-reason"
          data-reason={reason.key}
          title={reason.title}
          className="flex flex-wrap items-center gap-x-1.5 gap-y-0.5"
        >
          <span
            className={`px-2 py-0.5 rounded-full text-[11px] font-semibold whitespace-nowrap ${TONE_CLASSES[reason.tone]}`}
          >
            {reason.label}
          </span>
          {reason.detail && (
            <span className="text-xs text-text-secondary">{reason.detail}</span>
          )}
        </div>
      ))}
    </div>
  );
};
